import { voidFn } from '@simplisafe/ewok'
import * as O from 'fp-ts/lib/Option'
import { pipe } from 'fp-ts/lib/function'

import type { SprinklrLiveChatClient } from './sprinklr'

export function getSprChat(fn: (s: SprinklrLiveChatClient) => void) {
  const chat = O.fromNullable(globalThis.window?.sprChat)
  pipe(chat, O.fold(voidFn, fn))
}

export function setSprinklrChatAppId(id: string) {
  if (globalThis.window) {
    globalThis.window.sprChatSettings ||= {}
    globalThis.window.sprChatSettings['appId'] = id
  }
}
